<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Alert, Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;
	let value = settings.emeter_n.mismatch_threshold;
	let cache = value;
	const isValid = status.emeter_n.is_valid;

	const min = 0;
	const max = 100;
	let loading = false;

	let localIp = get_local_ip(device.id);

	const setNeutralMismatch = async () => {
		//ToDo need to be tested
		if (cache !== value) {
			let res: any = {};
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/emeter/n`, 'post', {
					mismatch_threshold: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: device.id,
					command: `mismatch_threshold`,
					payload: JSON.stringify({
						value: parseFloat(value),
						id: 3,
					}),
				});
			}

			if (res.isok) {
				settings.emeter_n.mismatch_threshold = value;
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
			}
			loading = false;
		}
	};
</script>

{#if isValid}
	<Text styleType="body-small" class="mb-s">
		{$format('description_for_neutral_mismatch')}
	</Text>
	<Input
		size="m"
		width="full"
		class="mb-s"
		bind:value
		type={'number'}
		{min}
		{max}
		step={0.01}
		on:change
		on:enter
		on:enter={setNeutralMismatch}
		id="input-qcok5x0"
		aria-label={$format('description_for_neutral_mismatch', {
			default: 'Neutral mismatch threshold',
		})}
	/>

	<Button {loading} class="mt-s" size="m" width="full" on:click={setNeutralMismatch}
		>{$format('button_save')}</Button
	>
{:else}
	<Alert
		type="info"
		isHeadingBold
		heading={$format('label_info')}
		class="mb-s"
		message={$format('description_for_missing_neutral_mismatch')}
	/>
{/if}
